const comunas = {
  "Alto Hospicio": {
    "Región": "Region de Tarapaca",
    "Transito": 4,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Huara": {
    "Región": "Region de Tarapaca",
    "Transito": 4,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pica": {
    "Región": "Region de Tarapaca",
    "Transito": 4,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pozo Almonte": {
    "Región": "Region de Tarapaca",
    "Transito": 4,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Iquique": {
    "Región": "Region de Tarapaca",
    "Transito": 4,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Antofagasta": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Mejillones": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Taltal": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Calama": {
    "Región": "Region de Antofagasta",
    "Transito": 3,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Pedro de Atacama": {
    "Región": "Region de Antofagasta",
    "Transito": 3,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Tocopilla": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Maria Elena": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Sierra Gorda": {
    "Región": "Region de Antofagasta",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Copiapo": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Tierra Amarilla": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Chañaral": {
    "Región": "Region de Atacama",
    "Transito": 3,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Diego de Almagro": {
    "Región": "Region de Atacama",
    "Transito": 3,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Vallenar": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Alto del Carmen": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Freirina": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Huasco": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Caldera": {
    "Región": "Region de Atacama",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Andacollo": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Coquimbo": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Higuera": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "La Serena": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Paiguano": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Vicuña": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Combarbala": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Monte Patria": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Ovalle": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Punitaqui": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Rio Hurtado": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Canela": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Illapel": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Los Vilos": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Salamanca": {
    "Región": "Region de Coquimbo",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Concon": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Valparaiso": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Viña del Mar": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Calera": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Hijuelas": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "La Cruz": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Nogales": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Quillota": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Calle Larga": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Los Andes": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Rinconada": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "San Esteban": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Casablanca": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "x",
    "Sa": 0
  },
  "Algarrobo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Cartagena": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "El Quisco": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "El Tabo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "San Antonio": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Santo Domingo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Isla de Pascua": {
    "Región": "Region de Valparaiso",
    "Transito": 4,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "El Monte": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Alhue": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Curacavi": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "3xsemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Maria Pinto": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "San Pedro": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Navidad": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Melipilla": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Peñaflor": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Talagante": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Catemu": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Llaillay": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Panquehue": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Putaendo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "San Felipe": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Santa Maria": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Limache": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Olmue": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Quilpue": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Villa Alemana": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Puchuncavi": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Quintero": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Cabildo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Petorca": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "La Ligua": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Papudo": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Zapallar": {
    "Región": "Region de Valparaiso",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Codegua": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Coinco": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Coltauco": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Doñihue": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Graneros": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Machali": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Mostazal": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Olivar": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Requinoa": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Rancagua": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Estrella": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Litueche": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Las Cabras": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Malloa": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Peumo": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Pichidegua": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Quinta de Tilcoco": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Rengo": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Vicente": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Chepica": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Chimbarongo": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Nancagua": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Placilla": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "San Fernando": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lolol": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Palmilla": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Peralillo": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Pumanque": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Santa Cruz": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Marchihue": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Paredones": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pichilemu": {
    "Región": "Region del Libertador Gral. Bernardo O’Higgins",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Maule": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "4xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Pencahue": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "San Clemente": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "San Rafael": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Talca": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Javier": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "4xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Curepto": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Licanten": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Hualañe": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Vichuquen": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Pelarco": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Rio Claro": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Curico": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Molina": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Rauco": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Romeral": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Sagrada Familia": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Teno": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Colbun": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Linares": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Villa Alegre": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Yerbas Buenas": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Longavi": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Retiro": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Constitucion": {
    "Región": "Region del Maule",
    "Transito": 2,
    "Frecuencia": "4xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Empedrado": {
    "Región": "Region del Maule",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Chanco": {
    "Región": "Region del Maule",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pelluhue": {
    "Región": "Region del Maule",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Coelemu": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Treguaco": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Concepcion": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Penco": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Tome": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Renaico": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Alto Biobio": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Antuco": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Cabrero": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Laja": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Los angeles": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Mulchen": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Nacimiento": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Negrete": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Quilaco": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Quilleco": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "San Rosendo": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Santa Barbara": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Yumbel": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Yungay": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Tucapel": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Coihueco": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Portezuelo": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Ranquil": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Bulnes": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "El Carmen": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pemuco": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pinto": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Quillon": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "San Ignacio": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Florida": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Chillan": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Chillan Viejo": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Santa Juana": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Arauco": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Cañete": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Contulmo": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Curanilahue": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "4xSemana",
    "Lu": "X",
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lebu": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Los alamos": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Tirua": {
    "Región": "Region del Biobio",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Cauquenes": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Ñiquen": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "San Carlos": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Fabian": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "San Nicolas": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Parral": {
    "Región": "Region del Maule",
    "Transito": 1,
    "Frecuencia": "4xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Cobquecura": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Ninhue": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Quirihue": {
    "Región": "Region de Ñuble",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Chiguayante": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Hualqui": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Coronel": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Hualpen": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lota": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "San Pedro de la Paz": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Talcahuano": {
    "Región": "Region del Biobio",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Los Sauces": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Puren": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Curacautin": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Lumaco": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Traiguen": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Victoria": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Carahue": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Cholchol": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Freire": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Galvarino": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Gorbea": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Lautaro": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Nueva Imperial": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Padre Las Casas": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Perquenco": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Pitrufquen": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Saavedra": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Temuco": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Teodoro Schmidt": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Tolten": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Vilcun": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Curarrehue": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Pucon": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Villarrica": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Angol": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Collipulli": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Ercilla": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Lonquimay": {
    "Región": "Region de La Araucania",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Cunco": {
    "Región": "Region de La Araucania",
    "Transito": 14,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Melipeuco": {
    "Región": "Region de La Araucania",
    "Transito": 14,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Puerto Montt": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Calbuco": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "3xsemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Cochamo": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Los Muermos": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Maullin": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Hualaihue": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Ancud": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Castro": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Chonchi": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Curaco de Velez": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Dalcahue": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Puqueldon": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Queilen": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Quellon": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Quemchi": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Quinchao": {
    "Región": "Region de Los Lagos (Chiloe)",
    "Transito": 5,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Fresia": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Frutillar": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Llanquihue": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Puerto Varas": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Osorno": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Union": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Lago Ranco": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Rio Bueno": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Puerto Octay": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Purranque": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Puyehue": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Rio Negro": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "San Juan de la Costa": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "San Pablo": {
    "Región": "Region de Los Lagos",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Coihaique": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Aisen": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Chaiten": {
    "Región": "Region de Los Lagos",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Chile Chico": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Cisnes": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Cochrane": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Futaleufu": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Guaitecas": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Lago Verde": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "O’Higgins": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 14,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Palena": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Rio Ibañez": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Tortel": {
    "Región": "Region Aysen del Gral.Carlos Ibañez del Campo",
    "Transito": 7,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Porvenir": {
    "Región": "Region de Magallanes y de la Antartica Chilena",
    "Transito": 13,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Punta Arenas": {
    "Región": "Region de Magallanes y de la Antartica Chilena",
    "Transito": 13,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Cabo de Hornos (Ex. Navarino) / Puerto Williams": {
    "Región": "Region de Magallanes y de la Antartica Chilena",
    "Transito": 14,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Natales": {
    "Región": "Region de Magallanes y de la Antartica Chilena",
    "Transito": 14,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Lampa": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Tiltil": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "1xSemana",
    "Lu": 0,
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": "X"
  },
  "Las Condes": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Conchali": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Recoleta": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Huechuraba": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Santiago": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lo Barnechea": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Providencia": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Vitacura": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "La Reina": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Florida": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Ñuñoa": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Peñalolen": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Colina": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Puente Alto": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": 0
  },
  "Macul": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Cisterna": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Granja": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "La Pintana": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Ramon": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "El Bosque": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Independencia": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Quilicura": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Renca": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Joaquin": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Cerro Navia": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Quinta Normal": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Cerrillos": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Estacion Central": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lo Espejo": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Lo Prado": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Maipu": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Padre Hurtado": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Pedro Aguirre Cerda": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Pudahuel": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Bernardo": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Miguel": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "San Jose de Maipo": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Pirque": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "2xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Isla de Maipo": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Buin": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Paine": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Calera de Tango": {
    "Región": "Region Metropolitana de Santiago",
    "Transito": 1,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Valdivia": {
    "Región": "Region de Los Rios",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Corral": {
    "Región": "Region de Los Rios",
    "Transito": 1,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Los Lagos": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Paillaco": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Futrono": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "2xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": 0
  },
  "Panguipulli": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": 0,
    "Ma": "X",
    "Mi": 0,
    "Ju": "X",
    "Vi": 0,
    "Sa": "X"
  },
  "Loncoche": {
    "Región": "Region de La Araucania",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Lanco": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  },
  "Mafil": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "1xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": 0,
    "Ju": 0,
    "Vi": 0,
    "Sa": 0
  },
  "Mariquina": {
    "Región": "Region de Los Rios",
    "Transito": 2,
    "Frecuencia": "3xSemana",
    "Lu": "X",
    "Ma": 0,
    "Mi": "X",
    "Ju": 0,
    "Vi": "X",
    "Sa": 0
  },
  "Arica": {
    "Región": "Region de Arica y Parinacota",
    "Transito": 6,
    "Frecuencia": "Diaria",
    "Lu": "X",
    "Ma": "X",
    "Mi": "X",
    "Ju": "X",
    "Vi": "X",
    "Sa": "X"
  }
};